import { gql } from '@apollo/client';
export default gql`
  query getOperationSalaryitems($ids: [String]) {
    getOperationSalaryitems(ids: $ids) {
      ok
      error
      count
      data {
        _id
        branch
        autoNo
        docNo
        desc
        time
        year
        month
        isPaid

        basicSalary
        extraSalary
        fullSalary

        bonos
        overtime
        deduction

        departmentId
        departmentName
        departmentNameAr

        employeeId
        employeeName
        employeeNameAr

        userId
        createdAt
        updatedAt
      }
    }
  }
`;
